import { render, staticRenderFns } from "./UserAccountOpeningHours.vue?vue&type=template&id=939d1020&"
import script from "./UserAccountOpeningHours.vue?vue&type=script&lang=js&"
export * from "./UserAccountOpeningHours.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountOpeningHours.vue?vue&type=style&index=0&id=939d1020&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports